/* src/app/shared/common-ui/lib/dropdown-item/dropdown-item.component.less */
:host {
  flex: none;
  display: flex;
}
:host .wrapper {
  flex: 1;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  min-height: 3.6rem;
  padding: 0.6rem 1.2rem;
  font-size: 1.5rem;
  line-height: 2rem;
  background: var(--color-default-input-background);
}
:host .wrapper.active {
  color: var(--color-default-static-text);
  background: var(--color-default-selected-background);
}
:host .wrapper:hover {
  color: var(--color-default-button-text-hover);
  background: var(--color-default-button-hover);
}
:host .wrapper:active {
  color: var(--color-alternative-button-text);
  background: var(--color-default-button-active);
}
:host .wrapper:disabled {
  color: var(--color-default-button-disabled);
  border: 0.1rem solid var(--color-default-button-disabled);
  cursor: initial;
  opacity: initial;
  pointer-events: none;
}
/*# sourceMappingURL=dropdown-item.component.css.map */
